
import { Component, Prop, Vue } from 'vue-property-decorator';
import IconClose from './IconClose.vue';
import { Venue } from '@/interfaces/models/Venue';
import { currencyByVenue } from '@/util/helper';

@Component({
  components: { IconClose },
})
export default class InfoBox extends Vue {
  @Prop({ type: Array }) public items!: any[];
  @Prop({ type: Object }) public venue!: Venue;

  get currency(): string {
    return currencyByVenue(this.venue);
  }

  public getPercentage(ratio: string): string {
    const percent: number = parseFloat(ratio) * 100;
    return percent.toFixed(2);
  }
}
